import { Component, AfterViewInit, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { CampaignsService } from "./campaigns.service";
import { CampaignsFilterModel } from "./campaign-filter.model";
import { ICampaignViewModel } from "./campaign.model";
import { SortModel } from "../shared/sort.model";
import { CampaignSortField } from "./campaign-sort.enum";
import { DropdownValue } from "../shared/dropdown.model";
import { PageSizeSelectionComponent } from "../shared/page-size-selection.component";
import { CampaignTabs } from "./campaign.enum";
import { ClaimsService } from "../core/services";
import { CampaignsFilterComponent } from "./campaigns-filter.component";
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";
import { SortService } from '../shared/sort.service';

@Component({
    moduleId: module.id,
    templateUrl: 'campaigns.component.html'
})
export class CampaignsComponent implements OnInit, AfterViewInit, OnDestroy {
    data: ICampaignViewModel[];
    errorMessage: string;
    pageNumber: number = 1;
    totalCount: number;
    pageSize: number = 0;
    showOverlay: boolean;
    brandSort: SortModel = new SortModel(CampaignSortField.Brand, SortModel.ascIcon);
    productSort: SortModel = new SortModel(CampaignSortField.Product, SortModel.disabledIcon);
    dspSort: SortModel = new SortModel(CampaignSortField.DSP, SortModel.disabledIcon);
    sspSort: SortModel = new SortModel(CampaignSortField.SSP, SortModel.disabledIcon);
    tradingDeskSort: SortModel = new SortModel(CampaignSortField.TradingDesk, SortModel.disabledIcon);
    countrySort: SortModel = new SortModel(CampaignSortField.CountryId, SortModel.disabledIcon);
    startDateSort: SortModel = new SortModel(CampaignSortField.StartDate, SortModel.disabledIcon);
    endDateSort: SortModel = new SortModel(CampaignSortField.EndDate, SortModel.disabledIcon);
    valueSort: SortModel = new SortModel(CampaignSortField.Value, SortModel.disabledIcon);
    nrRatingsSort: SortModel = new SortModel(CampaignSortField.NrRatings, SortModel.disabledIcon);
    avgRatingsSort: SortModel = new SortModel(CampaignSortField.AvgRatings, SortModel.disabledIcon);
    totalPlaysCountSort: SortModel = new SortModel(CampaignSortField.TotalPlaysCount, SortModel.disabledIcon);
    totalCompletedViewsCountSort: SortModel = new SortModel(CampaignSortField.TotalCompletedViewsCount, SortModel.disabledIcon);
    totalEarningsSort: SortModel = new SortModel(CampaignSortField.TotalEarnings, SortModel.disabledIcon);
    deliveryIndexSort: SortModel = new SortModel(CampaignSortField.DeliveryIndex, SortModel.disabledIcon);
    avgCompletedViewsPerDaySort: SortModel = new SortModel(CampaignSortField.AvgCompletedViewsPerDay, SortModel.disabledIcon);
    timeElapsedSort: SortModel = new SortModel(CampaignSortField.TimeElapsed, SortModel.disabledIcon);
    deliveredSort: SortModel = new SortModel(CampaignSortField.Delivered, SortModel.disabledIcon);
    clicksCountSort: SortModel = new SortModel(CampaignSortField.ClicksCount, SortModel.disabledIcon);
    ctrSort: SortModel = new SortModel(CampaignSortField.Ctr, SortModel.disabledIcon);
    sharesCountSort: SortModel = new SortModel(CampaignSortField.SharesCount, SortModel.disabledIcon);
    strSort: SortModel = new SortModel(CampaignSortField.Str, SortModel.disabledIcon);
    interactionsSort: SortModel = new SortModel(CampaignSortField.Interactions, SortModel.disabledIcon);
    itrSort: SortModel = new SortModel(CampaignSortField.Itr, SortModel.disabledIcon);
    totalAllocatedViewsSort: SortModel = new SortModel(CampaignSortField.TotalAllocatedViews, SortModel.disabledIcon);
    useLightClass: boolean = true;
    showKeyStats: boolean = true;
    showDeliveryStats: boolean = false;
    showInteractionStats: boolean = false;
    showAdminActionButtons: boolean = false;
    private filters: CampaignsFilterModel;
    private sortField: SortModel;
    private sortDirectionAsc: boolean = true;
    private inXhrGetCampaigns: any;
    private currentTab: number;

    @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent
    @ViewChild("campaignsFilter") campaignsFilterComponent: CampaignsFilterComponent

    constructor(private campaignsService: CampaignsService,
        private claimsService: ClaimsService,
        private scrollService: CustomHorizontalScrollService,
        private sortService: SortService) { }

    ngOnInit() {
        this.sortField = this.brandSort;
        this.showAdminActionButtons = this.claimsService.isSambaAdmin() || this.claimsService.isPublisherAdmin();
        this.currentTab = 1;
    }

    public getCampaigns(page: number): void {
        this.campaignsFilterComponent.disable();
        if (this.inXhrGetCampaigns) {
            this.inXhrGetCampaigns.unsubscribe();
        }
        this.showOverlay = true;
        this.inXhrGetCampaigns = this.campaignsService.getFilteredCampaigns(this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.filters)
            .subscribe((res: any) => {
                this.totalCount = res.json().total;
                this.pageNumber = page;
                this.data = <Array<ICampaignViewModel>>res.json().data;
            }, error => this.errorMessage = error, () => this.onCompletedGetCampaigns());
    }

    private onCompletedGetCampaigns(): void {
        this.showOverlay = false;
        this.campaignsFilterComponent.enable();
        this.toggleHorizontalScroll();
        let self = this;
        setTimeout(function () {
            self.showTab(self.currentTab);
        }, 1);
    }

    onResize(event) {
        this.toggleHorizontalScroll();
    }

    private toggleHorizontalScroll() {
        let self = this;
        setTimeout(function () {
            self.scrollService.toggleHorizontalScroll();
        }, 10);
    }

    onSortChanged(sort: SortModel) {
        let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
        this.sortField = sortResult.existingSortModel;
        sort = sortResult.selectedSortModel;
        this.sortDirectionAsc = sortResult.sortDiresctionAsc;
        this.getCampaigns(1);
    }

    onPageSizeChanged(item: DropdownValue) {
        this.pageSize = item.value;
        this.pageNumber = 1;
        this.getCampaigns(this.pageNumber);
    }

    ngAfterViewInit() {
        this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
        this.getCampaigns(1);
        // tree select init
        $("#publishers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
        $("#providers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
    }

    public filter(filters: CampaignsFilterModel) {
        this.filters = filters;
        if (this.pageSizeSelectionComponent && this.pageSize)
            this.getCampaigns(1);
    }

    public showTab(tab: number) {
        $('.active-tab').removeClass('active-tab');
        this.showKeyStats = false;
        this.showDeliveryStats = false;
        this.showInteractionStats = false;
        switch (tab) {
            case CampaignTabs.KeyStats:
                $('#keyStats').addClass('active-tab');
                this.showKeyStats = true;
                this.currentTab = CampaignTabs.KeyStats;
                break;
            case CampaignTabs.DeliveryStats:
                $('#campaignDelivery').addClass('active-tab');
                this.showDeliveryStats = true;
                this.currentTab = CampaignTabs.DeliveryStats;
                break;
            case CampaignTabs.InteractionStats:
                $('#campaignInteraction').addClass('active-tab');
                this.showInteractionStats = true;
                this.currentTab = CampaignTabs.InteractionStats;
                break;
        }
        this.toggleHorizontalScroll();
    };

    onDeleteCampaign(event, campaignId: number) {
        if (confirm('Are you sure you want to delete this item?')) {
            event.preventDefault();
            event.stopPropagation();
            this.campaignsService.deleteCamapign(campaignId)
                .subscribe(() =>
                    this.getCampaigns(this.pageNumber)
                );
        }
    }

    ngOnDestroy() {
        if (this.inXhrGetCampaigns) {
            this.inXhrGetCampaigns.unsubscribe();
        }
        this.scrollService.toggleHorizontalScroll(false);
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaigns.component.ts